import React from "react";

import styles from "./SectionStatusColumnHeaders.module.scss";

const SectionStatusColumnHeaders = () => (
  <div className={styles.sectionStatusColumnHeaders}>
    <span>Proposal</span>
    <span>Due</span>
    <span>Section Status</span>
    <span className={styles.sectionStatusColumnHeaders__right}>Sections</span>
    <span className={styles.sectionStatusColumnHeaders__right}>Complete</span>
  </div>
);

export default SectionStatusColumnHeaders;
